





















































































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
import { useAssets } from "@/hooks/useAssets";
import { formatDateStringRecent } from "@/utils/text";
import { Study } from "@/psychlab/types/studies";
import * as StudiesAPI from "@/services/api/studies";
import { useRecentStudies } from "./useRecentStudies";
import { Dictionary } from "@/utils/types";


export default defineComponent({
	setup(props){

		const loaded = ref(false);

		const assetHooks = useAssets();

		const studies = ref<Study[]>([]);

		const sessionCount = ref<Dictionary<number>>({});

		const days = computed(() => 7);

		const {
			studies:recentStudies,
			peekDate,
		} = useRecentStudies(studies, days);

		const getBlueprintName = (s:Study) => {
			const a = assetHooks.assets.value.find(a => a._id === s.target.study);
			return a ? a.name : "";
		};

		const getRoute = (id:string) => {
			return {
				name:"Run.Group",
				params:{
					groupId:id
				}
			}
		};

		const loadData = async () => {
			try {
				console.log(peekDate.value);
				const r = await StudiesAPI.getStudiesPaginated({
					limit:20,
					page:1,
					// "lastVisited[gte]":peekDate.value,
					"lastVisited[gte]":peekDate.value,

					sort:"-lastVisited",
					select:"name target lastVisited created enabled",
					// enabled:true,
				});
				
				const count = await StudiesAPI.countStudiesSessions(r.studies.map(s => s._id), { "created[gte]":peekDate.value });

				sessionCount.value = count;
				studies.value = r.studies;
			}
			catch(err){}
			loaded.value = true;
		};

		const formatDisplayDate = (v:string) => {
			return formatDate(new Date(v), "eeee MMM d y @ HH:mm");
		};

		loadData();

		return {
			studies:recentStudies,
			formatDateStringRecent,
			getRoute,
			getBlueprintName,
			loaded,
			days,
			formatDisplayDate,
			sessionCount,
		};
	}
});

